import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import Admin from './Admin';

const AUTH_KEY = 'hngt_admin_auth';
const ADMIN_PASSWORD = 'hngt1111bela';

const ProtectedAdmin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Check authentication on mount
    const savedAuth = localStorage.getItem(AUTH_KEY);
    if (savedAuth === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
    }
    setIsChecking(false);
  }, []);

  const handleAuthenticated = () => {
    setIsAuthenticated(true);
  };

  if (isChecking) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <p className="text-[#6B7280]">Carregando...</p>
      </div>
    );
  }

  return isAuthenticated ? (
    <Admin />
  ) : (
    <AdminLogin onAuthenticated={handleAuthenticated} />
  );
};

export default ProtectedAdmin;